const aoubaidaReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const aoubaidaScrollRail = (rail, direction) => {
  rail.scrollBy({
    left: direction * Math.max(rail.clientWidth * 0.82, 280),
    behavior: aoubaidaReduceMotion ? 'auto' : 'smooth',
  });
};

const aoubaidaSyncRailButtons = (wrap) => {
  const rail = wrap.querySelector('[data-ao-rail]');
  const previous = wrap.querySelector('[data-ao-rail-scroll="previous"]');
  const next = wrap.querySelector('[data-ao-rail-scroll="next"]');

  if (!rail || !previous || !next) return;

  previous.disabled = rail.scrollLeft <= 1;
  next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
};

const aoubaidaInitRails = (scope = document) => {
  scope.querySelectorAll('[data-ao-rail-wrap]').forEach((wrap) => {
    if (wrap.dataset.aoubaidaReady === 'true') return;

    const rail = wrap.querySelector('[data-ao-rail]');
    if (!rail) return;

    wrap.dataset.aoubaidaReady = 'true';
    rail.addEventListener('scroll', () => aoubaidaSyncRailButtons(wrap), { passive: true });
    window.addEventListener('resize', () => aoubaidaSyncRailButtons(wrap), { passive: true });
    aoubaidaSyncRailButtons(wrap);
  });
};

const aoubaidaInitHero = (scope = document) => {
  scope.querySelectorAll('[data-ao-hero]').forEach((hero) => {
    if (hero.dataset.aoubaidaReady === 'true') return;

    const track = hero.querySelector('[data-ao-hero-track]');
    const slides = Array.from(hero.querySelectorAll('[data-ao-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-ao-hero-dot]'));
    const previous = hero.querySelector('[data-ao-hero-previous]');
    const next = hero.querySelector('[data-ao-hero-next]');

    if (!track || slides.length < 2) return;

    hero.dataset.aoubaidaReady = 'true';
    let activeIndex = 0;
    let frame = null;

    const update = () => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      activeIndex = index;
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const moveTo = (index) => {
      const destination = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[destination].offsetLeft,
        behavior: aoubaidaReduceMotion ? 'auto' : 'smooth',
      });
    };

    previous?.addEventListener('click', () => moveTo(activeIndex - 1));
    next?.addEventListener('click', () => moveTo(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => moveTo(index)));
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        update();
        frame = null;
      });
    }, { passive: true });
    hero.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') moveTo(activeIndex - 1);
      if (event.key === 'ArrowRight') moveTo(activeIndex + 1);
    });
    update();
  });
};

const aoubaidaInitProductGalleries = (scope = document) => {
  scope.querySelectorAll('[data-ao-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.aoubaidaGalleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-ao-product-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-ao-product-thumbnail]'));
    const media = gallery.querySelector('.ao-product__media');
    const previous = gallery.querySelector('[data-ao-product-gallery-previous]');
    const next = gallery.querySelector('[data-ao-product-gallery-next]');
    const status = gallery.querySelector('[data-ao-product-gallery-status]');
    const zoomButton = gallery.querySelector('[data-ao-gallery-zoom]');
    const dialog = gallery.querySelector('[data-ao-gallery-dialog]');
    const dialogImage = gallery.querySelector('[data-ao-gallery-dialog-image]');
    const dialogClose = gallery.querySelector('[data-ao-gallery-dialog-close]');

    if (!slides.length) return;

    gallery.dataset.aoubaidaGalleryReady = 'true';
    let activeIndex = slides.findIndex((slide) => !slide.hidden);
    let swipeStart = null;
    if (activeIndex < 0) activeIndex = 0;

    const setZoomAvailability = () => {
      if (!zoomButton) return;
      const image = slides[activeIndex]?.querySelector('img');
      zoomButton.hidden = !image;
    };

    const setActive = (index, shouldScroll = true) => {
      activeIndex = (index + slides.length) % slides.length;
      const activeSlide = slides[activeIndex];
      if (!activeSlide) return;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        if (!isActive) slide.querySelectorAll('video').forEach((video) => video.pause());
      });

      thumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.dataset.aoMediaId === activeSlide.dataset.aoMediaId;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive && shouldScroll) {
          thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: aoubaidaReduceMotion ? 'auto' : 'smooth' });
        }
      });

      if (status) status.textContent = activeSlide.dataset.aoMediaLabel || '';
      setZoomAvailability();
    };

    const openZoom = () => {
      const image = slides[activeIndex]?.querySelector('img');
      if (!dialog || !dialogImage || !image) return;

      dialogImage.src = image.currentSrc || image.src;
      dialogImage.alt = image.alt;
      if (!dialog.open) dialog.showModal();
    };

    previous?.addEventListener('click', () => setActive(activeIndex - 1));
    next?.addEventListener('click', () => setActive(activeIndex + 1));
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const index = slides.findIndex((slide) => slide.dataset.aoMediaId === thumbnail.dataset.aoMediaId);
        if (index >= 0) setActive(index);
      });
    });
    media?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.pointerType === 'mouse' || event.target.closest('button, a, input, select, textarea, video, model-viewer, iframe')) return;
      swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });
    media?.addEventListener('pointerup', (event) => {
      if (!swipeStart || swipeStart.id !== event.pointerId) return;

      const deltaX = event.clientX - swipeStart.x;
      const deltaY = event.clientY - swipeStart.y;
      swipeStart = null;

      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      setActive(activeIndex + (deltaX < 0 ? 1 : -1));
    });
    media?.addEventListener('pointercancel', () => {
      swipeStart = null;
    });
    zoomButton?.addEventListener('click', openZoom);
    dialogClose?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    gallery.addEventListener('aoubaida:variant-change', (event) => {
      const mediaId = event.detail?.mediaId;
      const index = slides.findIndex((slide) => slide.dataset.aoMediaId === String(mediaId));
      if (index >= 0) setActive(index);
    });

    setActive(activeIndex, false);
  });
};

const aoubaidaInitProductForms = (scope = document) => {
  scope.querySelectorAll('[data-ao-product]').forEach((productSection) => {
    if (productSection.dataset.aoubaidaProductReady === 'true') return;

    const form = productSection.querySelector('form');
    const stickyButton = productSection.querySelector('[data-ao-sticky-submit]');
    const variantData = productSection.querySelector('[data-ao-product-variants]');
    const variantIdInput = productSection.querySelector('[data-ao-variant-id]');
    const selectors = Array.from(productSection.querySelectorAll('[data-ao-option-selector]'));
    const price = productSection.querySelector('[data-ao-current-price]');
    const comparePrice = productSection.querySelector('[data-ao-compare-price]');
    const stickyPrice = productSection.querySelector('[data-ao-sticky-price]');
    const stock = productSection.querySelector('[data-ao-product-stock]');
    const addButton = productSection.querySelector('[data-ao-add-to-cart]');
    const addLabel = productSection.querySelector('[data-ao-add-label]');
    const stickyLabel = productSection.querySelector('[data-ao-sticky-label]');
    const gallery = productSection.querySelector('[data-ao-product-gallery]');

    if (!form) return;

    productSection.dataset.aoubaidaProductReady = 'true';

    stickyButton?.addEventListener('click', () => {
      if (stickyButton.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.querySelector('[type="submit"]')?.click();
      }
    });

    if (!variantData || !variantIdInput || !selectors.length) return;

    let variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    const updateLabel = (element, available) => {
      if (!element) return;
      element.textContent = available ? element.dataset.aoAvailableLabel : element.dataset.aoSoldOutLabel;
    };

    const updateAvailability = (available) => {
      if (stock) {
        stock.textContent = available ? stock.dataset.aoInStockLabel : stock.dataset.aoSoldOutLabel;
        stock.classList.toggle('is-sold-out', !available);
      }
      if (addButton) addButton.disabled = !available;
      if (stickyButton) stickyButton.disabled = !available;
      updateLabel(addLabel, available);
      updateLabel(stickyLabel, available);
    };

    const update = () => {
      const selectedOptions = selectors.map((selector) => selector.querySelector('[data-ao-option-value]:checked')?.value);
      if (selectedOptions.some((value) => typeof value === 'undefined')) return;

      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index]));
      if (!variant) {
        updateAvailability(false);
        return;
      }

      variantIdInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (comparePrice) {
        comparePrice.textContent = variant.comparePrice || '';
        comparePrice.hidden = !variant.comparePrice;
      }
      updateAvailability(variant.available);
      gallery?.dispatchEvent(new CustomEvent('aoubaida:variant-change', { detail: { mediaId: variant.featuredMediaId } }));
    };

    selectors.forEach((selector) => {
      selector.addEventListener('change', update);
    });
    update();
  });
};

const aoubaidaInitDirectionalHeader = (scope = document) => {
  const header = scope.querySelector('.ao-mobile-header');
  const section = header?.closest('.shopify-section');
  if (!section || section.dataset.aoubaidaDirectionalHeaderReady === 'true') return;

  section.dataset.aoubaidaDirectionalHeaderReady = 'true';
  section.classList.add('ao-header-group--auto-hide');

  let lastScrollY = Math.max(0, window.scrollY || window.pageYOffset);
  let frame = null;

  const update = () => {
    frame = null;
    const currentY = Math.max(0, window.scrollY || window.pageYOffset);
    const difference = currentY - lastScrollY;
    const menuIsOpen = Boolean(header.querySelector('[data-ao-mobile-menu][open]'));
    const hasFocusedControl = header.contains(document.activeElement);

    if (currentY <= section.offsetHeight + 10 || menuIsOpen || hasFocusedControl) {
      section.classList.remove('is-hidden');
      lastScrollY = currentY;
      return;
    }

    if (difference > 7) {
      section.classList.add('is-hidden');
      lastScrollY = currentY;
    } else if (difference < -7) {
      section.classList.remove('is-hidden');
      lastScrollY = currentY;
    }
  };

  window.addEventListener('scroll', () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(update);
  }, { passive: true });

  header.addEventListener('focusin', () => section.classList.remove('is-hidden'));
  header.addEventListener('toggle', () => section.classList.remove('is-hidden'), true);
  update();
};

const aoubaidaInit = (scope = document) => {
  aoubaidaInitDirectionalHeader(scope);
  aoubaidaInitRails(scope);
  aoubaidaInitHero(scope);
  aoubaidaInitProductGalleries(scope);
  aoubaidaInitProductForms(scope);
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-ao-rail-scroll]');
  if (!button || button.disabled) return;

  const wrap = button.closest('[data-ao-rail-wrap]');
  const rail = wrap?.querySelector('[data-ao-rail]');
  if (!rail) return;

  aoubaidaScrollRail(rail, button.dataset.aoRailScroll === 'next' ? 1 : -1);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => aoubaidaInit(), { once: true });
} else {
  aoubaidaInit();
}

document.addEventListener('shopify:section:load', (event) => aoubaidaInit(event.target));
